<template lang="pug">
  include /mixins.pug
  +b.floor
    +e.aside.--variant_2(v-if="categories.length")
      center-categories(
        ref="categories"
        :categories="categories"
        @shop:select="selectPavilion"
        @category:select="categorySelect"
        @category:reset="categoryReset"
        :is-loading="isLoading"
      )
    +e.main.--variant_2
      +b.tabs
        +e.heading
          +e.item.--variant_2(
            v-for="item in buildings"
            @click.prevent='chooseCenter(item)'
            :class="{'is-active': currentBuilding.label == item.label, 'is-readonly': isLoading}"
          )
            +e.SPAN.text {{ item.badgeTitle }}
        +e.content
          +e.main.--space_md
            +b-context('floor')
              +e.map-wrapper
                +e.part.--variant_1
                  +b.c-circle.--vertical(
                    v-for="floor in floors"
                    @click.prevent='chooseFloor(floor, "reset")'
                    :class="{'is-active': currentFloor.number == floor.number}"
                  ) {{ floor.number }}
                +e.part.--variant_2
                  +b.center-map
                    +b.preloader.--absolute(v-if="isLoading || isPavilionInfoLoading")
                      +e.item
                    +b.svg-wrapper.--interactive(ref="svgWrapper")
                      +e.IMG.logo.is-hidden(
                        v-for="item in pavilions"
                        :ref="`logo_${item.mapKey}`"
                        :src="item.shop ? item.shop.logoMono : ''"
                      )
                      +e.IMG.background(
                        :src="currentFloor.mapBg"
                        ref="mapBg"
                      )
                      panZoom(
                        v-if="!isDesktop"
                        :options="{minZoom: 1, boundsPadding: 0.7}"
                        @panstart="panStart"
                        @panend="panEnd"
                        @transform="onMapTransform"
                      )
                        +e.element(v-html="currentFloor.mapPlaces")
                      +e.element(
                        v-if="isDesktop"
                        v-html="currentFloor.mapPlaces"
                      )
                +e.part.--variant_3
                  shop-preview(
                    v-if="pavilionInfo"
                    :pavilion-info="pavilionInfo"
                  )
</template>

<script>
/* eslint-disable */
import { buildingFloorList, pavilionRetrieve } from '@services/map.service'
import { OpenMessageModal } from '@utils/submit'
import { autocomleteResource, nestedCategoryMap } from '@services/autocomplete.service'
import { toDataURL } from '@utils/transformers'
import FloorMap from '@mixins/FloorMap'
import panZoom from 'vue-panzoom'
import Vue from 'vue'

Vue.use(panZoom)
export default {
  name: 'CenterView',
  mixins: [
    FloorMap,
  ],
  data() {
    return {
      currentBuilding: {},
      currentFloor: {},
      pavilionInfo: null,
      preselectPavilion: null,
      buildings: [],
      floors: [],
      categories: [],
      isMounted: true,
      isLoading: false,
      currentCategoryLabel: null,
      dragging: false,
      isDesktop: false,
      isPavilionInfoLoading: false,
    }
  },
  mounted() {
    this.getBuildings()
    this.getAutocomplete('category')
    const xl = 1200
    if (window.innerWidth >= xl) {
      this.isDesktop = true
    }
  },
  methods: {
    getBuildings() {
      autocomleteResource.execute({ label: 'build' }).then(res => {
        const { data } = res
        const { items } = data
        this.buildings = items
        this.preselectBuilding()
      })
    },

    getHash() {
      let urlHash = window.location.hash
      if (urlHash) {
        urlHash = urlHash.replace('#', '')
        const splitedHash = urlHash.split(';')
        return splitedHash
      }
      return false
    },

    preselectBuilding() {
      let building = this.buildings[0]
      const splitedHash = this.getHash()

      if (splitedHash) {
        const buildingLabel = splitedHash[0]
        building = this.buildings.find(el => {
          if (el.label == buildingLabel) {
            return el
          }
        })
      }

      this.chooseCenter(building)
    },

    async getAutocomplete(key) {
      await nestedCategoryMap.execute({ label: key }).then(res => {
        const { data } = res
        const { items } = data
        this.categories = items
      })
    },

    resetInfo() {
      this.pavilionInfo = null
      this.currentFloor = {}
      this.pavilions = []
      this.currentCategoryLabel = null
      this.unhighlightPolygon()
      if (this.$refs.categories) {
        this.$refs.categories.resetCategory()
        this.$refs.categories.resetChildCategory()
      }
    },

    chooseCenter(item) {
      this.currentBuilding = item
      this.resetInfo()
      this.$nextTick(() => {
        this.getBuildingInfo(item)
      })
    },

    sringifyFn(data) {
      if (data) {
        return JSON.parse(JSON.stringify(data))
      }
      return
    },

    chooseFloor(item, trigger) {
      this.currentFloor = {}
      this.isPavilionInfoLoading = true
      if (trigger == 'reset') {
        this.resetInfo()
      }
      if (!item.initialPavilions) {
        item.initialPavilions = this.sringifyFn(item.pavilions)
      }
      this.currentFloor = this.sringifyFn(item)
      this.currentFloor.initialPavilions = this.sringifyFn(item.initialPavilions)
      this.currentFloor.pavilions = this.sringifyFn(item.initialPavilions)
      if (trigger != 'reset') {
        this.$nextTick(() => {
          this.activatePolygonInteraction()
        })
      } else {
        this.initActions()
      }
      const timeout = 1000
      setTimeout(() => {
        this.isPavilionInfoLoading = false
      }, timeout)
    },

    getBuildingInfo(item) {
      this.isLoading = true
      this.unhighlightPolygon()
      const params = {
        label: item.label,
      }
      buildingFloorList.execute(params).then(result => {
        const { data } = result
        const { items } = data
        this.floors = items.map(floor => {
          // decode svg string to html element
          toDataURL(floor.mapPlaces).then(res => {
            const svg = atob(
              res.replace(/data:image\/svg\+xml;base64,/, '')
            )
            floor.mapPlaces = svg
          })
          return floor
        })

        this.preselectFloor()

        const timeout = 500
        setTimeout(() => {
          this.getShopList().then(async () => {
            const promises = [this.getShopCategories, this.checkPavilionPreselection]
            Promise.all(promises.map(async func => {
              await func()
            })).then(() => {
              this.isLoading = false
            })
          })
        }, timeout)
      }).catch(() => {
        this.isLoading = false
      })
    },

    checkPavilionPreselection() {
      if (this.preselectPavilion) {
        this.selectPavilion(this.preselectPavilion)
        this.preselectPavilion = null
      }
    },

    preselectFloor() {
      let floor = this.floors.find(el => el.isMain) || this.floors[0]
      const splitedHash = this.getHash()

      if (splitedHash && this.isMounted) {
        const pavilionLabel = decodeURIComponent(splitedHash[1])
        this.floors.forEach(el => {
          el.pavilions.forEach(pavilion => {
            if (pavilion.label == pavilionLabel) {
              floor = el
              this.preselectPavilion = {
                pavilionLabel,
                mapKey: pavilion.mapKey,
                pavilion,
              }
            }
          })
        })
        this.isMounted = false
      }
      const initialPavilions = JSON.parse(JSON.stringify(floor.pavilions))
      this.currentFloor = floor
      this.currentFloor.initialPavilions = initialPavilions
      this.initActions()
    },

    async activatePolygonInteraction() {
      await this.collectPolygons()

      await this.createPavilion()

      this.initPolygonEvents()
      this.$nextTick(() => {
        this.getPolygonCenter()
      })
    },

    async collectPolygons() {
      const timeout = 100
      let svgEl = []
      this.svgWrapper = this.$refs.svgWrapper

      const setSvgElement = () => {
        this.svgEl = svgEl[0]
        this.polygons = this.svgEl.getElementsByTagName('polygon')
      }

      return await new Promise(resolve => {
        const checkExistSvg = setInterval(() => {
          if (!svgEl.length) {
            svgEl = this.svgWrapper.getElementsByTagName('svg')
          } else {
            clearInterval(checkExistSvg)
            resolve(setSvgElement())
          }
        }, timeout)
      })
    },

    async initActions() {
      await this.collectPolygons()
      await this.createPavilion('empty')

      this.initPolygonEvents()
    },

    initPolygonEvents() {
      this.polygons.forEach(polygon => {
        const polygonLabel = polygon.getAttribute('label')
        const polygonId = polygon.getAttribute('id')

        const selectPavilion = () => {
          if (!this.dragging) {
            const params = {
              pavilionLabel: polygonLabel,
              mapKey: polygonId,
              trigger: 'click',
            }
            this.selectPavilion(params)
          }
        }

        polygon.onmouseover = () => {
          this.setLogoImage(polygonId, 'logo')
        }

        polygon.onmouseleave = () => {
          if (!polygon.classList.contains('is-active')) {
            this.setLogoImage(polygonId, 'logoMono')
          }
        }

        polygon.onclick = () => {
          selectPavilion()
        }
        if (!this.isDesktop) {
          polygon.ontouchend = () => {
            selectPavilion()
          }
        }
      })
    },

    getShopCategories() {
      this.categories = this.categories.map(category => {
        category.shops = []
        if (category.isShowChilds) {
          category.childs = category.childs.map(child => {
            child.shops = []
            this.floors.forEach(floor => {
              floor.pavilions.forEach(pavilion => {
                if (pavilion.shop.categories.includes(child.label)) {
                  child.shops = this.addShopToCategory(floor, pavilion, child.shops)
                }
              })
            })
            return child
          })
        }
        this.floors.forEach(floor => {
          floor.pavilions.forEach(pavilion => {
            if (pavilion.shop.categories.includes(category.label)) {
              category.shops = this.addShopToCategory(floor, pavilion, category.shops)
            }
          })
        })
        return category
      })
    },

    addShopToCategory(floor, pavilion, item) {
      const obj = {
        floor: floor.number,
        ...pavilion.shop,
        pavilionLabel: pavilion.label,
        mapKey: pavilion.mapKey,
      }

      const shop = item.find(el => {
        if (el.label === obj.label &&
          el.floor === obj.floor) {
          return el
        }
      })

      // if the category doesn't include
      // shop with the same label and floor
      // we add his to category
      if (!shop) item.push(obj)
      return item
    },

    getPavilions(selectedPavilion, trigger) {
      const shops = this.currentFloor.initialPavilions.filter(pavilion => {
        if (this.currentCategoryLabel && pavilion) {
          let condition = pavilion.shop.label == selectedPavilion.shop.label &&
            pavilion.shop.categories.includes(this.currentCategoryLabel)
          if (trigger) {
            condition = pavilion.shop.label == selectedPavilion.shop.label
          }
          if (condition) {
            return pavilion
          }
        } else if (pavilion.shop.label == selectedPavilion.shop.label) {
          return pavilion
        }
      })
      return shops
    },

    selectPavilion(item, category) {
      // select floor on pavilion change
      this.floors.forEach(floor => {
        if (floor.number == item.floor &&
          item.floor != this.currentFloor.number) {
          this.chooseFloor(floor)
        }
      })

      // activate category if we got pavilion from url hash
      if (item.pavilion) {
        const { categories } = item.pavilion.shop
        if (categories) {
          this.$refs.categories.activateCategory(categories[0])
          this.categorySelect(categories[0])
        }
      } else if (category) {
        this.categorySelect(category.label)
      }
      if (item.pavilionLabel) {
        this.unhighlightPolygon('click')

        // find pavilion with selected mapKey
        const selectedPavilion = this.currentFloor.initialPavilions.find(pavilion => {
          if (pavilion.mapKey == item.mapKey ||
            pavilion.label == item.pavilionLabel) {
            return pavilion
          }
        })

        // get pavilions with the same shop label
        const shops = this.getPavilions(selectedPavilion)

        const shopsOfCurrentFloor = this.getPavilions(selectedPavilion, true)

        this.hideLogos(item, shops)
        // highlight the same shop
        if (!this.currentCategoryLabel) {
          this.polygons.forEach((polygon, index) => {
            const polygonId = polygon.getAttribute('id')
            let logo = this.$refs[`logo_${polygonId}`]
            if (logo && logo[0] && this.pavilions[index]) {
              logo = logo[0]
              logo.classList.add('is-hidden')
            }
            if (polygonId === item.mapKey) {
              this.logoCentering(polygon, index)
            }
          })
        }
        setTimeout(() => {
          shopsOfCurrentFloor.forEach(el => {
            this.highlightPolygon(el.mapKey, 'click')
          })
        }, 500)

        // get shop info
        this.getPavilionInfo(item)
      } else {
        const title = this._('Информации о павильоне не найдено.')
        OpenMessageModal(title, this)
      }
    },

    hideLogos(item, shops) {
      if ('click' === item.trigger) {
        this.polygons.forEach((polygon, index) => {
          const polygonId = polygon.getAttribute('id')
          let logo = this.$refs[`logo_${polygonId}`]
          const shop = this.currentFloor.pavilions.find(el => el.mapKey === polygonId)
          if (logo && logo[0] && !shop) {
            logo = logo[0]
            logo.classList.add('is-hidden')
          }
        })
      }
    },

    getPavilionInfo(pavilion) {
      const params = { label: pavilion.pavilionLabel }
      if (!this.isPavilionInfoLoading) {
        this.isPavilionInfoLoading = true
        pavilionRetrieve.execute(params).then(res => {
          const { data: { item } } = res
          this.isPavilionInfoLoading = false
          item.shop.rating = parseFloat(item.shop.rating)
          this.selectPavilionInfo(item)
        }).catch(() => {
          this.isPavilionInfoLoading = false
        })
      }
    },

    selectPavilionInfo(item) {
      this.pavilionInfo = item

      // show pavilion info in modal on screens less then 1680
      const mac = 1680
      if (window.innerWidth < mac) {
        const modal = () => import('@components/Modals/ShopPreviewModal')
        this.$modal.show(modal, {
          pavilionInfo: this.pavilionInfo,
        }, {
          class: 'v--modal-variant_2',
        })
      }
    },

    categorySelect(label) {
      this.unhighlightPolygon()

      // filtering pavilions by selected category
      this.currentCategoryLabel = label
      const initialPavilions = JSON.parse(JSON.stringify(this.currentFloor.initialPavilions))
      this.currentFloor.pavilions = initialPavilions.filter(el => {
        if (el.shop.categories.includes(label)) {
          return el
        }
      })

      this.activatePolygonInteraction()
    },

    categoryReset() {
      this.categorySelect(null)
      this.pavilionInfo = null
      this.unhighlightPolygon()
    },

    panEnd() {
      const timeout = 300
      setTimeout(() => {
        this.dragging = false
      }, timeout)
    },

    panStart() {
      this.dragging = true
    },

    onMapTransform(event) {
      this.getPolygonCenter('zoom')
      const transform = event.getTransform()
      const { scale, x, y } = transform
      this.$refs.mapBg.style.transform = `matrix(${scale}, 0, 0, ${scale}, ${x}, ${y})`
    },
  },
}
</script>
